
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
// @Component({
//   name: "assess",
// })

export default  {

  data() {
        return {
		        tableData:[],
		        pageNo:1,
		        pageSize:10,
		        form:{},
                totalNum:0
		  
        };
    },
    mounted() {

      this.getList(1);
    },
    methods: {

      getList(num:any){

        let datas = [];
	  	  this.pageNo = num;
	  	  let paramter = {
	  	  	'pageNum':this.pageNo,
	  	  	'pageSize':this.pageSize
	  	  };
        this.$http.get("producteval/list", {params:paramter}).then((res: any) => {
            this.totalNum = res.data.data.total;
	  	  	  datas = res.data.data.data;
			      this.pageNo = num;
			      this.pageSize = res.data.data.pageSize;
	  	  	  this.tableData = datas;
            this.tableData = this.tableData.map(item=>{

            if(item.enable == 1) {

              item.enable = true;
            } else {

              item.enable = false;
            }
              return item;
            });
         });
      },

      handleSizeChange(val: number) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.pageNo = 1;
      },

      handleCurrentChange(val: number) {
        console.log(`当前页: ${val}`);
        this.pageNo = val;
        this.getList(this.pageNo);
      },
      handlePublishStatusChange(index,row){
        console.log(row);
      },
      handleCommentDetail(index,row){
		
		    console.log(row);
	      this.$router.push({path: '/Community/qualityTestDetail',query:row})
		// this.$router.push({path: '/Community/checkDetail',query:row})
      },
      onSubmit() {
        console.log(this.form);
      },

    }

}
